<script setup>
import { useI18n } from 'vue-i18n';
import SingleHookIntegrationPage from '../shared/SingleHookIntegrationPage.vue';

const { t } = useI18n();
</script>

<template>
  <SingleHookIntegrationPage
    integration-id="google_translate"
    :header-title="t('INTEGRATION_SETTINGS.GOOGLE_TRANSLATE.HEADER')"
    :empty-title="t('INTEGRATION_SETTINGS.GOOGLE_TRANSLATE.EMPTY_STATE')"
    :empty-description="t('INTEGRATION_SETTINGS.GOOGLE_TRANSLATE.DESCRIPTION')"
    :connect-button-label="
      t('INTEGRATION_SETTINGS.GOOGLE_TRANSLATE.CONNECT_BUTTON')
    "
    :disconnect-button-label="
      t('INTEGRATION_SETTINGS.GOOGLE_TRANSLATE.DISCONNECT_BUTTON')
    "
    :connected-title="t('INTEGRATION_SETTINGS.GOOGLE_TRANSLATE.CONNECTED')"
    :connected-description="
      t('INTEGRATION_SETTINGS.GOOGLE_TRANSLATE.CONNECTED_DESCRIPTION')
    "
    :disconnect-confirm="
      t('INTEGRATION_SETTINGS.GOOGLE_TRANSLATE.DISCONNECT.CONFIRM')
    "
    icon="i-lucide-languages"
    icon-class="bg-gradient-to-br from-blue-500 to-sky-600"
    logo-file="/dashboard/images/integrations/google-translate.png"
  />
</template>
